const columns = [
  {
    name: <span className="font-weight-bold fs-13">Nome do Titular</span>,
    sortable: true,
    width: '18%',
    selector: (cell) => cell.customer,
  },
  {
    name: <span className="font-weight-bold fs-13">Plano</span>,
    selector: (row) => row.plan,
    sortable: false,
    width: '20%',
  },
  {
    name: <span className="font-weight-bold fs-13">Corretor</span>,
    selector: (row) => row.seller_name,
    sortable: false,
  },
  {
    name: <span className="font-weight-bold fs-13">Escritório</span>,
    selector: (row) => row.office_name,
    sortable: false,
    width: '20%',
  },
  {
    name: <span className="font-weight-bold fs-13">Situação</span>,
    sortable: false,
    selector: (cell) => {
      return (
        <div>
          <span className={`badge badge-soft-${cell.status_color}`}>
            {cell.status}
          </span>
        </div>
      );
    },
  },
];

export { columns };
